module.exports = __webpack_public_path__ + "img/img17.306b745a.png";